import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatLocalizationService } from 'src/app/core/services/date-format-localization.service';

@Pipe({
  name: 'timeUntil',
  pure: false,
})
export class TimeUntilPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private dateFormatLocalization: DateFormatLocalizationService
  ) { }

  transform(date: Date | string | null | undefined): string {
    if (!date) {
      return '';
    }

    const targetDate = new Date(date);
    const now = new Date();
    const diffMs = targetDate.getTime() - now.getTime();

    if (diffMs <= 0) {
      return '';
    }

    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    const formattedDate = targetDate.toLocaleDateString(this.dateFormatLocalization.getCurrentConfig().locale, {
      day: 'numeric',
      month: 'short',
    });

    if (diffDays === 1) {
      return this.translate.instant('notifications.postpone.returnsInOneDay', { date: formattedDate });
    }

    return this.translate.instant('notifications.postpone.returnsInDays', {
      days: diffDays,
      date: formattedDate,
    });
  }
}
